import { apiClient } from "@config/apiClient";
import { Deal, DealSourceTypesResponse, DealStage } from "@app-types/common.type";
import { IPagedResponse } from "@interfaces/responses.interface";
import { API_URL } from "@config/constants";

class DealService {
  private URL = `${API_URL}/deals`;

  async getDeals(params: URLSearchParams): Promise<IPagedResponse<Deal>> {
    return apiClient.get(`${this.URL}/deals/?${params.toString()}`);
  }

  async createDeal(formData: FormData): Promise<Deal> {
    return apiClient.post(`${this.URL}/deals/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  async getDealSourceTypes(): Promise<DealSourceTypesResponse> {
    return await apiClient.get(`${this.URL}/deal-source-types/`);
  }

  async getDealStages(): Promise<IPagedResponse<DealStage>> {
    return apiClient.get(`${this.URL}/stages/?limit=100`);
  }
}

const dealService = new DealService();
export default dealService;
